import { Owner, StoreApplicant } from '@funnels/types';

import getApplicantName from './getApplicantName';

export default function getApplicantsFullnameFromOwners(owners: Owner[], applicants: StoreApplicant[]) {
  if (!owners) {
    return [];
  }
  return owners
    .map((o) => {
      const applicant: StoreApplicant | undefined = applicants.find((a) => a.id === o.applicantId);

      if (!applicant) {
        return null;
      }

      const fullName = getApplicantName([applicant], applicant.id);

      return fullName;
    })
    .filter((o) => o) as string[];
}
